<template>
  <v-dialog
    v-model="dialog"
    :width="!showDone? '510px': '330px'">
    <div class="dialog-container">
      <h3>Undo Endorsement</h3>

      <p v-if="!showDone">Where do you want to refund the charged amount?</p>
      <p v-else-if="showCheque">The endorsement has been undone, and the previously charged amount has been added to the cheque queue.</p>
      <p v-else-if="showCredits">The endorsement has been undone, and the previously charged amount has been added to the customer's credits.</p>
      <p v-else>The endorsement has been undone. Any refund for this endorsement was cancelled.</p>
      <div
        v-if="!showDone"
        class="dialog-footer">
        <v-button @click="dialog = false">Cancel</v-button>
        <v-button
          type="primary"
          @click="handlerCheque">Cheque</v-button>
        <v-button
          type="primary"
          @click="handlerCredits">Credits</v-button>
      </div>
      <div v-else>
        <v-button
          type="primary"
          @click="handlerDone">Done</v-button>
      </div>

    </div>
  </v-dialog>
</template>
<script>
import { undoEndorsement } from '@/api/endorsement'
export default {
  name: 'UndoEndorsement',
  props: {
    dialogType: {
      type: Number,
      default: 1
    },
    id: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      // dialogType: 0, // normal, undo
      undoType: 0, // 1-cheque, 2-credits
    }
  },
  computed: {
    showDone() {
      if(this.dialogType === 1 && this.undoType === 0 ) {
        return false
      }
      return true
    },
    showCheque() {
      return (this.dialogType === 1 && this.undoType === 1)
    },
    showCredits() {
      return (this.dialogType === 1 && this.undoType === 2)
    },
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
      this.undoType = 0
    },
    handlerDone() {
      this.$emit('done')
      this.dialog = false
    },
    handlerCheque() {
      this.network().undoEndorsement(1)
      // this.undoType = 1
    },
    handlerCredits() {
      // this.undoType = 2
      this.network().undoEndorsement(2)
    },
    network() {
      return {
        undoEndorsement: async (refundType) => {
          // 1-cheque, 2-credits
          const { data } = await undoEndorsement({
            id: this.id,
            refund_type: refundType
          })
          this.undoType = refundType
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      h3 {
        padding-bottom: 5px;
      }
      p {
        
        padding-bottom: 10px;
        font-size: 16px;
        color: #616266;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
    }
</style>